import VFooter from "@/components/m_footer.vue";
import VHeader from "@/components/m_header.vue";
export default {
  name: "VApp",
  components: {
    VHeader: VHeader,
    VFooter: VFooter
  }
};